import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fi-we',
  templateUrl: './fi-we.component.html',
  styleUrls: ['./fi-we.component.css']
})
export class FiWeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
